import { useEffect, useState } from 'react';

const useIsNotSafari = () => {
  const [isNotSafari, setIsNotSafari] = useState(false);

  useEffect(() => {
    const ua = navigator?.userAgent?.toLowerCase();
    setIsNotSafari(
      ua.indexOf('mobile') > -1 && (ua.indexOf('crios') > -1 || ua.indexOf('fxios') > -1 || ua.indexOf('android') > -1),
    );
  }, []);

  return isNotSafari;
};

export default useIsNotSafari;
